import { netImpactLensTexts } from '@upright/ui/common/upright/core/impact-lenses/net-impact/texts';
import { KBUrl, TooltipReadMoreKbLink } from '@upright/ui/common/upright/kb-urls';

export const sdgLensTexts = {
  SourceDescription: netImpactLensTexts.SourceDescription,
  SourceTooltipContent: () => (
    <>
      <div>
        The Upright net impact model is a mathematical model of the global economy that integrates information from a
        variety of public data sources to produce comparable net impact profiles of companies, along with complementary
        indicators.
        <TooltipReadMoreKbLink href={KBUrl.METHODOLOGY_SDGS} text="Read more about Upright's SDG methodology" />
      </div>
    </>
  ),
  LensTitle: () => <>UN SDG alignment</>,
  LensDescription: () => <>Alignment with UN Sustainable Development Goals</>,
  LensTooltipContent: () => (
    <>
      Alignment with the UN Sustainable Development Goals, based on estimated amount of revenue that is aligned or
      misaligned with the United Nations Sustainable Development Goals. The Upright Model estimates the alignment based
      on the products and services that companies produce.
      <TooltipReadMoreKbLink href={KBUrl.METRICS_SDGS} />
    </>
  ),
};
